import { useEffect, useState } from 'react'

import { ProductType } from '../../../types'
import { get } from '../../../utils/api'

export interface PrebuiltClasses {
  id: number
  name: string
  description: string
  classSet: []
  productTypeId: number
}

export const usePrebuiltClassesData = (productType: ProductType) => {
  const [prebuiltClasses, setPrebuiltClasses] = useState<PrebuiltClasses[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    get<PrebuiltClasses[]>(
      `/pre_built_classes_set/?product_type=${productType}`
    ).then((data) => {
      setPrebuiltClasses(data)
      setIsLoading(false)
    })
  }, [productType])

  return { prebuiltClasses, isLoading }
}
